const pageNameKey = "iconButton";

export const iconButtonEn = {
  [pageNameKey]: {
    iconButtonAltText: "Icon button",
  },
};

export const iconButtonPtBr = {
  [pageNameKey]: {
    iconButtonAltText: "Botão de ícone",
  },
};

export const iconButtonDe = {
  [pageNameKey]: {
    iconButtonAltText: "Symbolbutton",
  },
};

export const iconButtonZhHans = {
  [pageNameKey]: {
    iconButtonAltText: "图标按钮",
  },
};

export const iconButtonIt = {
  [pageNameKey]: {
    iconButtonAltText: "Pulsante icona",
  },
};

export const iconButtonEs = {
  [pageNameKey]: {
    iconButtonAltText: "Botón de icono",
  },
};

export const iconButtonNl = {
  [pageNameKey]: {
    iconButtonAltText: "Pictogramknop",
  },
};

export const iconButtonTr = {
  [pageNameKey]: {
    iconButtonAltText: "Simge düğmesi",
  },
};
